module.exports = __webpack_public_path__ + "img/mingyong7.0df33988.png";